<template>
	<div class="formContainer has-font-manrope">
		<b-modal v-model:modelValue="transactionModalActive" style="height: 100%">
			<iframe :src="transactionModal" style="width: 100%; height: 95%"></iframe>
		</b-modal>
		<NetworkMetamaskModal v-if="modals.showNetworkMetamaskModal" />
		<div class="headerImage">
			<a href="https://www.morpher.com" target="_blank" alt="Morpher Homepage">
				<img class="image" src="@/assets/auth/morpher-logo.svg" alt="Morpher Logo" />
			</a>

			<!-- start executing -->
			<div v-if="migrationInProgress">
				<!-- Use page-title class like in PortfolioFunds -->
				<h2 data-cy="pageHeadingText" class="authTitle">{{ $t('auth.MIGRATE_BASE')}}</h2>

				<div class="mt-12">
					<p ref="verifiction_text" data-cy="logInDescription" class="authText fade">
						{{ $t('auth.VERIFYING_YOUR_ACCOUNT_DESCRIPTION_1') }} 
					</p>
				</div>
				<img class="image" src="@/assets/icons/spinner.svg" alt="Spinner" />

				
			</div>
				<!-- start migration -->

			<div v-else-if="migrationData && (migrationData.migration_state === 'not started' || migrationData.migration_state === 'started')">
				<!-- Use page-title class like in PortfolioFunds -->
				<h2 data-cy="pageHeadingText" class="authTitle">{{ $t('auth.EXCITING_FEATURE')}}</h2>

				<p data-v-4803f210="" class="description-text mt-2 has-text-left">{{ $t('auth.MOVE_EVERYTHING')}}</p>

				<p data-v-4803f210="" v-if="user?.payload?.migrate_chain_reset !== true" class="description-text mt-2 has-text-left">{{ $t('auth.MOVE_EVERYTHING_2')}}</p>

				<div class="error-container is-flex" v-if="user?.payload?.migrate_chain_reset === true">
					<img src="@/assets/icons/new/alert-triangle.svg" alt="Warning Triangle Icon">
					<div class="is-flex is-flex-direction-column">
						<div class="info-head">{{ $t('auth.ACCOUNT_RESET_HEAD')}}</div>
						<div class="info-text">{{ $t('auth.ACCOUNT_RESET_TEXT')}}</div>

					</div>
				</div>

				<div class="learn-container is-flex"  @click="openLearn">
					<img src="@/assets/icons/new/coinbase-icon.svg" alt="Coinbase Icon">
					<div class="is-flex is-flex-direction-column">
						<div class="info-head">{{ $t('auth.LEARN_BASE_HEAD')}}</div>
						<div class="info-text">{{ $t('auth.LEARN_BASE_TEXT')}}</div>

					</div>
					<img src="@/assets/icons/new/arrow-right.svg" alt="Right caret">
				</div>

				<div class="warn-container is-flex" v-if="user?.payload?.migrate_chain_reset !== true">
					<img src="@/assets/icons/new/info.svg" alt="Info Icon">
					<div class="is-flex is-flex-direction-column">
						<div class="info-text">{{ $t('auth.SLTP_WARNING')}}</div>

					</div>
				</div>



				<!-- Use plain-primary-btn  -->
				<button 
					class="button plain-primary-btn mt-40 is-full-width"
					@click="executeMigration"
					:disabled="migrationInProgress"
					:class="{ 'is-loading': migrationInProgress }"
				>
					{{ migrationData.migration_state === 'started' ? $t('auth.COMPLETE_MIGRATION') : $t('auth.START_MIGRATION') }}
				</button>

				<div class="migrate-time">
					{{ $t('auth.MIGRATION_TIME') }}
				</div>

				<!-- Back to Logon page -->
				<p class="loginLink">
					<a @click="logoutUser()" class="login-router transition-faster">
						<span>{{ $t('LOGOUT') }}</span>
					</a>
				</p>

				<div v-if="migrationError" class="notification is-danger mt-12">
					{{ migrationError }}
				</div>
			</div>

			<div v-else-if="migrationData && migrationData.migration_state === 'complete'">

				<h2 data-cy="pageHeadingText" class="authTitle">{{ $t('auth.ACCOUNT_MIGRATED') }}</h2>
				
				<p data-v-4803f210="" class="description-text mt-2">{{ $t('auth.MIGRATION_SUCCESSFUL')}}</p>

				<button 
					class="button plain-primary-btn mt-4"
					@click="startMorpher"
					:disabled="loginInProgress"
					:class="{ 'is-loading': loginInProgress }"
				>
				{{ $t('auth.START_MORPHER')}}
					
				</button>


			</div>

			<div v-else>
				<!-- Use page-title class like in PortfolioFunds -->
				<h2 data-cy="pageHeadingText" class="authTitle">{{ $t('auth.EXCITING_FEATURE')}}</h2>

				<p data-v-4803f210="" class="description-text mt-2 has-text-left">{{ $t('auth.MOVE_EVERYTHING')}}</p>

				<p data-v-4803f210="" class="description-text mt-2 has-text-left">{{ $t('auth.MOVE_EVERYTHING_2')}}</p>

				<div class="error-container is-flex" v-if="user?.payload?.migrate_chain_reset === true">
					<img src="@/assets/icons/new/alert-triangle.svg" alt="Warning Triangle Icon">
					<div class="is-flex is-flex-direction-column">
						<div class="info-head">{{ $t('auth.ACCOUNT_RESET_HEAD')}}</div>
						<div class="info-text">{{ $t('auth.ACCOUNT_RESET_TEXT')}}</div>

					</div>
				</div>

				<div class="learn-container is-flex" @click="openLearn">
					<img src="@/assets/icons/new/coinbase-icon.svg" alt="Coinbase Icon">
					<div class="is-flex is-flex-direction-column">
						<div class="info-head">{{ $t('auth.LEARN_BASE_HEAD')}}</div>
						<div class="info-text">{{ $t('auth.LEARN_BASE_TEXT')}}</div>

					</div>
					<img src="@/assets/icons/new/arrow-right.svg" alt="Right caret">
				</div>

				<div class="warn-container is-flex">
					<img src="@/assets/icons/new/info.svg" alt="Info Icon">
					<div class="is-flex is-flex-direction-column">
						<div class="info-text">{{ $t('auth.SLTP_WARNING')}}</div>

					</div>
				</div>

				
				<p data-v-4803f210="" class="description-text mt-2">{{ $t('auth.LOADING_DATA') }}...</p>
			</div>

		</div>

		<div v-if="migrationData" style="display: none">
			<!-- Use number-headers/highlighted-secondary for details -->
			<p class="number-headers is-size-14">Positions to migrate:</p>
			<p class="highlighted-secondary mb-2">{{ migrationData.oldPositions || 0 }}</p>
			<p class="number-headers is-size-14">Balance to migrate:</p>
			<p class="highlighted-secondary mb-4">{{ roundFormatter(migrationData.oldBalance) || 0 }} MPH</p>
			<!-- Add more details from migrationData if needed -->
			<!-- <pre>{{ JSON.stringify(migrationData, null, 2) }}</pre> -->

			
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useAdminStore } from '@/store/modules/admin';
import { UserService } from '@/services/UserService'; // Import UserService
import type { getChainMigrationData_getChainMigrationData as MigrationDataType } from '@/graphql/user/types/getChainMigrationData'; // Import the specific type for the data
import { useModalsStore } from '@/store/modules/modals';
import { useUserStore } from '@/store/modules/user';
import { useContractStore } from '@/store/modules/contract';
import { ERROR } from '@/store/mutation-types';
import Password from 'vue-simple-password-meter';
import { mapActions, mapState } from 'pinia';
import { useStatusStore } from '@/store/modules/status';
import { encodePacked, keccak256, type WalletClient } from 'viem';
import type { TAddress } from '@/types/graphql-global-types';
import WalletMixin from '@/mixins/wallet.mixin';
import NetworkMetamaskModal from '@/components/modals/NetworkMetamaskModal.vue';

/* @group Application_View */
/*
  <h4> <b> Airdrop page </b> </h4>
  <br> - Shows all portfolios with ability to close only active one
  <br> - Update Profile form to change password/username
*/
export default defineComponent({
	name: 'MigrateChain',
	components: {

		Password,
		NetworkMetamaskModal
	},
	mixins: [WalletMixin],
	data(): {
		migrationInProgress: boolean;
		loginInProgress: boolean;
		isLoading: boolean; // Added loading state
		migrationData: MigrationDataType | null; // Added state for migration data
		migrationError: string | null; // Added state for errors
		small: boolean;
		windowWidth: number;
		verifycount: number;
		interval?: NodeJS.Timeout;
		transactionModalActive: boolean;
		transactionModal?: string;

	} {
		return {

			migrationInProgress: false,
			loginInProgress: false,
			isLoading: false, // Initialize loading state
			migrationData: null, // Initialize migration data
			migrationError: null, // Initialize error state
			small: false,
			windowWidth: window.innerWidth - (this.small ? 600 : 0),
			verifycount: 1,
			interval: undefined,
			transactionModalActive: false,
			transactionModal: ''

		};
	},
	computed: {
		...mapState(useAdminStore, {
			config: (state) => state.config,
		}),
		...mapState(useUserStore, {
			activePortfolio: (state) => state.activePortfolio,
			user: (state) => state.data,
			impersonating: (state) => state.impersonating,
		}),
		...mapState(useContractStore, {
			eth_address: (state) => state.eth_address,
			walletType: (state) => state.walletType,
			wrongNetwork: (state) => state.wrongNetwork,
			wrongWallet: (state) => state.wrongWallet,
			isLoggedInWallet: (state) => state.isLoggedInWallet,
			provider: (state) => state.provider,
			morpherOracle: (state) => state.morpherOracle,
			walletClient: (state) => state.walletClient as any,
		}),
		...mapState(useModalsStore, {
			modals: (state) => state,
		}),

	},
	watch: {
		// Watch user data in case it loads after mount or changes
		user: {
			handler(newUser) {
				if (newUser?.eth_address) {
					this.fetchMigrationData();
				}
			},
			immediate: true, // Run handler immediately if user data is already available
		},
		migrationInProgress(newValue) {

			if (newValue) {
				this.verifycount = 1;

				if (this.interval) {
					clearInterval(this.interval)
					this.interval = undefined;
				}
				this.interval = setInterval(() => {
					this.verifycount += 1;
					if (this.verifycount == 3) {
						if (this.$refs.verifiction_text) {
							(this.$refs.verifiction_text as InstanceType<typeof HTMLParagraphElement>).className = 'authText fade2'
						}
						if (this.interval)
							clearInterval(this.interval)
						this.interval = undefined;

					}
					if (this.$refs.verifiction_text) {

						(this.$refs.verifiction_text as InstanceType<typeof HTMLParagraphElement>).innerText = this.$t('auth.VERIFYING_YOUR_ACCOUNT_DESCRIPTION_' + this.verifycount);
					}


				}, 3000)
			} else {
				if (this.interval) {
					clearInterval(this.interval)
					this.interval = undefined;
				}
			}
			},

	},
	mounted() {
		// Fetch data when component mounts if user is available
		if (this.user?.eth_address) {
			this.fetchMigrationData();
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});

		if (window.posthog) {
			window.posthog.startSessionRecording()
		}
		

	},
	beforeUnmount() { // Use beforeUnmount in Vue 3
		window.removeEventListener('resize', this.onResize);
	},

	methods: {
		...mapActions(useStatusStore, {
			error: ERROR,

		}),
		...mapActions(useContractStore, {
			switchChain: 'switchChain',
		}),
		...mapActions(useUserStore, {
			getTokenUserData: 'getTokenUserData',
			logout: 'logout',

		}),
		...mapActions(useModalsStore, {
			toggleWalletSignatureModal: 'toggleWalletSignatureModal'
		}),

		head() {
			return {
				meta: [{ hid: 'robots', name: 'robots', content: 'noindex' }],
			};
		},
		onResize() {
			this.windowWidth = window.innerWidth - (this.small ? 600 : 0);
		},
		/**
		 * Fetches the chain migration data for the current user.
		 */
		async fetchMigrationData(clear: boolean = true) {
			if (!this.user?.eth_address) {
				this.migrationError = 'User address not found. Cannot fetch migration data.';
				return;
			}
			this.isLoading = true;
			this.migrationError = null;

			if (clear) {
				this.migrationData = null; // Reset previous data
			}

			try {
				const response = await UserService.getChainMigrationData({ eth_address: this.user.eth_address });

				if (response.data?.getChainMigrationData) {
					this.migrationData = response.data.getChainMigrationData;
				} else if (response.errors) {
					//console.error('GraphQL Errors:', response.errors);
					this.migrationError = `Error fetching migration data: ${response.errors[0]?.message || 'Unknown error'}`;
					this.error(this.migrationError); // Use status store error handling
				} else {
					this.migrationError = 'Failed to fetch migration data. Response was empty.';
				}
			} catch (err: any) {
				//console.error('Error fetching migration data:', err);
				this.migrationError = (err.message || err).toString();
				this.error(this.migrationError); // Use status store error handling
			} finally {
				this.isLoading = false;
			}
		},
		async startMorpher() {

			if (window.posthog) {
				window.posthog.stopSessionRecording()
			}
			

			this.loginInProgress = true
			await this.fetchMigrationData(false);
			// Optionally show a success message that migration is processing

			await this.getTokenUserData({
				loading: false,
				component: this
			});

			if (this.user?.wallet_type == 'metamask') {
				await this.switchChain(this.provider)
				
				let address = window.location.origin + '/trade/'
				window.location.href = address;
				window.open(address, '_top')
				
			} else {
				let address = window.location.origin + '/trade/'
				window.location.href = address;
				window.open(address, '_top')
			}
			


		},
		logoutUser () {
			this.logout()

		},
		/**
		 * Executes the chain migration process.
		 */
		async executeMigration() {
			if (!this.user?.eth_address || !this.walletClient) {
				this.migrationError = 'User address or wallet client not available. Cannot start migration.';
				this.error(this.migrationError);
				return;
			}
			if (this.migrationData?.migration_state === 'complete') {
				this.migrationError = 'Migration is already complete.';
				this.error(this.migrationError);
				return;
			}

			

			
			this.migrationError = null;

			try {
				let walletReady = await this.checkWalletReady(false)
				if (!walletReady) {
					return this.migrationError = 'Wallet not connected, please log in before migrating.'
				}

				if (this.user?.wallet_type === 'metamask' || this.user?.wallet_type === 'walletconnect') {
					this.toggleWalletSignatureModal(true)
				} else {
					this.migrationInProgress = true;
				}

				// 1. Sign the message
				const signature = await this.signMessage();

				if (!this.migrationInProgress) {

					this.migrationInProgress = true;
					this.toggleWalletSignatureModal(false)
				}

				// 2. Call the chainMigration mutation
				const response = await UserService.chainMigration({
					signature: signature,
					step: this.migrationData?.migration_state === 'started' ? 'complete' : 'start',
				});

				if (response.data?.chainMigration?.status == 'completed') {
					// Migration completed successfully

					await this.fetchMigrationData();



				} else if (response.errors) {
					//console.error('GraphQL Errors during migration:', response.errors);
					this.migrationError = `Migration failed: ${response.errors[0]?.message || 'Unknown error'}`;
					this.error(this.migrationError);
				} else if (response.data?.chainMigration && response.data?.chainMigration?.status) {
					await this.fetchMigrationData();
				}
				 else {
					this.migrationError = 'Migration request failed. Response was unexpected.';
					this.error(this.migrationError);
				}
			} catch (err: any) {
				//console.error('Error executing migration:', err);
				this.migrationError = (err.message || err).toString();
				this.error(this.migrationError);
			} finally {
				this.migrationInProgress = false;
				this.toggleWalletSignatureModal(false)
			}
		},

		openLearn() {
			const url = this.supportArticleLink('BaseMigrate');
			// open in a new tab on smaller screens
			if (window.innerWidth <= 768) {
				window.open(url, '_blank');
			} else {
				this.transactionModal = url;
				this.transactionModalActive = true;
			}
		},

		/**
		 * Generates a signature mimicking the specific packing and hashing logic
		 * used by the migration contracts for authorization.
		 * @returns The generated signature string.
		 */
		async signMessage(): Promise<TAddress> {
			const message = 'I authorize migration of all my positions from plasma chain to Base L2';
			const userAddress = this.user?.eth_address as TAddress;
			if (!userAddress) {
				throw new Error('User eth address not found.');
			}
			// Use the *new* chain ID for signing as per contract expectation for the target chain
			const chainId = import.meta.env.VITE_CHAIN_ID_NEW; // Ensure this points to the TARGET chain ID

			if (!chainId) {
				// Consider fetching dynamically or ensuring it's always set
				throw new Error('Target chain ID (VITE_CHAIN_ID_NEW) is not configured.');
			}

			if (!this.walletClient) {
				throw new Error('No wallet client found.');
			}

			// 1. Pack message, user address, and *target* chain ID
			const packedData = encodePacked(['string', 'address', 'uint256'], [message, userAddress, BigInt(chainId)]);

			// 2. Hash the packed data
			const messageHash = keccak256(packedData);

			const wallet = this.walletClient as WalletClient;
			// 3. Sign the hash using EIP-191 standard (Ethereum Signed Message)
			const signature = await wallet.signMessage({
				message: { raw: messageHash },
				account: userAddress,
			});

			return signature;
		},

		// initialize method seems redundant now, replaced by fetchMigrationData triggered by watcher/mount
		/*
		async initialize() {
			// Initialization logic if any remains besides fetching data
		},
		*/
	},
});
</script>

<style scoped lang="scss">
@use "sass:color";

// Import shared styles or define new ones based on PortfolioFunds
@use '@/styles/variables.scss' as variables; // Adjust path if needed

.authTitle {
	font-size: 28px;
	font-weight: 700;
	line-height: 38px;
	margin-top: 25px;
	color: #333333;
}

.flat-box {
	// Styles copied or adapted from PortfolioFunds.vue or global styles
	background: #fff;
	border-radius: 12px;
	padding: 24px;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 1px 2px rgba(16, 24, 40, 0.06);
	border: 1px solid #eaecf0;
}

.number-headers {
	// Styles copied or adapted from PortfolioFunds.vue
	color: #686475;
	font-weight: 700;
	line-height: 20px;
}

.highlighted-primary {
	// Styles copied or adapted from PortfolioFunds.vue
	color: variables.$primary; 
	font-weight: 700;
}

.highlighted-secondary {
	// Styles copied or adapted from PortfolioFunds.vue
	color: #333; // Example
	font-weight: 500;
}

.button.plain-primary-btn {
	// Styles copied or adapted from PortfolioFunds.vue button styles
	background-color: variables.$primary;
	color: white;
	border: none;
	padding: 12px 24px;
	border-radius: 8px;
	font-weight: 700;
	transition: background-color 0.3s;

	&:hover {
		background-color: color.adjust(variables.$primary, $lightness: -10%)
	}

	&.is-loading {
		// Add loading styles if needed
		color: transparent !important;
		pointer-events: none;
		&:after {
			// Bulma's loading spinner
			//@include loader;
			position: absolute;
			left: calc(50% - (1em / 2));
			top: calc(50% - (1em / 2));
		}
	}
}

// Add Bulma spacing helpers if not globally available
.mt-4 { margin-top: 1rem !important; }
.mb-2 { margin-bottom: 0.5rem !important; }
.mb-4 { margin-bottom: 1rem !important; }

// Ensure container has some padding if section class is removed from root

.formContainer {
	display: flex;
	flex-direction: column;
	margin: auto auto;
	width: 360px;

}

.description-text {
	font-size: 0.875rem;
	line-height: 1.25rem;
	overflow: hidden;
	text-align: center;

}
.headerImage img {
	display: block;
	margin-left: auto;
	margin-right: auto;
}
.headerImage {
	width: 100%;
}
.full-width-input {
		display: flex;
		flex-direction: column;
		width: 100%;
	}
	
	.authText {
	font-weight: 400;
	color: #686475;
	margin-top: 12px;
	font-size: 16px;
}

.authText.fade {
	height: 50px;
	-webkit-animation: fadeinout 3s linear forwards;
	animation: fadeinout 3s linear forwards;
	 opacity: 0;
	animation-iteration-count: 10;
}

.authText.fade2 {
	height: 50px;
	-webkit-animation: fadeIn 2s linear forwards;
	animation: fadeIn 2s linear forwards;
	opacity: 0;
}


@keyframes fadeIn {
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}

@-webkit-keyframes fadeIn {
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}

@-webkit-keyframes fadeinout {
	50% {
		opacity: 1;
	}
}

@keyframes fadeinout {
	50% {
		opacity: 1;
	}

}

.error-container {
	border-radius: 8px;
	background: #FFF0F3;
	padding: 16px;
	margin-top: 24px;
	align-items: center;
	text-align: left;
	gap: 8px;

}
.error-container img {
	width: 24px;
	height: 24px;;
}

.warn-container {
	border-radius: 8px;
	background: #FFF9E3;
	padding: 16px;
	margin-top: 24px;
	align-items: center;
	text-align: left;
	gap: 8px;

}
.warn-container img {
	width: 24px;
	height: 24px;;
}
.migrate-time {
	color: #686475;
	margin-top: 24px;
}
.is-full-width {
		width: 100%;
	}
.learn-container {
	border-radius: 12px;
	border: 1px solid #ECEEF3;

	background: #F8F9FB;

	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.02);
	padding: 16px;

	align-items: center;
	text-align: left;

	gap: 8px;
	margin-top: 24px;
	cursor: pointer;

}
.info-head {
	color: var(--Dark-Gray, #333);
	font-size: 14px;
	font-weight: 700;
	line-height: 20px; 
}
.info-text {
	color: var(--Dark-Gray, #333);
	font-size: 12px;
	font-weight: 400;
	line-height: 18px; /* 150% */
}
.learn-container img {
	width: 24px;
	height: 24px;;
}
</style>
